module.exports = __webpack_public_path__ + "static/media/menu-comunidade.eb0d5852.svg";